import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DeviceTable from "components/deviceTable";
import TestInfoTable from "components/testInfo";
import { setTestInfo } from "store/slices/firebaseSlice";
import { collection, getDocs } from "firebase/firestore";
import { db } from "services/firebase";

function TestInfoLayout() {
  const dispatch = useDispatch();
  const { clientId, testInfoData, deviceIds } = useSelector((state) => state.firebase);
  const [selectedDevice, setSelectedDevice] = useState(null);

  useEffect(() => {
    if (!clientId || !selectedDevice) return;

    const fetchTestInfoData = async () => {
      const snapshot = await getDocs(
        collection(db, "Results", clientId, "devices", selectedDevice, "test")
      );
      const data = [];
      for (const docSnap of snapshot.docs) {
        const result = docSnap.data();
        if (result.Date && result.Date.toDate) {
          result.Date = result.Date.toDate().toLocaleString();
        }
        if (result.date && result.date.toDate) {
          result.date = result.date.toDate().toLocaleString();
        }
        data.push(result);
      }
      dispatch(setTestInfo(data));
    };

    fetchTestInfoData();
  }, [selectedDevice]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={2.4}>
            <DeviceTable
              clientId={clientId}
              deviceIds={deviceIds}
              selectedDevice={selectedDevice}
              onDeviceSelect={setSelectedDevice}
            />
          </Grid>

          {selectedDevice && (
            <Grid item xs={12} md={9}>
              <TestInfoTable selectedDevice={selectedDevice} testInfoData={testInfoData} />
            </Grid>
          )}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default TestInfoLayout;
